import { GridRowId } from '@mui/x-data-grid-pro';

const enum Pages {
  ROOT = '/',
  ONBOARDING = '/onboarding',
  NO_PERMISSIONS = '/wait',
  NOT_AUTHORIZED = '/not-authorized',
  NOT_FOUND = 'not-found',
  CHANGE_PASSWORD = 'profile/change-password',
  USERS = 'users',
  USER_GROUPS = 'user-groups',
  SECTOR_BRIDGES = 'sector-bridges',
  BRIDGE_ACTS = 'bridge-acts',
  GAS_ROUTES = 'gas-routes',
  OPERATIONAL_INCOMES = 'operational-incomes',
  ACTUAL_INCOMES = 'actual-incomes',
  FORM_NINE = 'form-nine',
  FORM_TEN = 'form-ten',
  MONTHLY_PCP = 'monthly-physical-chemical-parameters',
  AUTH_CALLBACK = '/callback',
  OPERATIONAL_EXPENSES = 'operational-expenses',
  REPORTS = 'reports',
  REPORTS_LIST = 'reports-list',
  ORDERED_CAPACITY_EXCESSES = 'ordered-capacity-excesses',
  NATURAL_GAS_DISTRIBUTION = 'natural-gas-distribution',
  DISTRIBUTION_TARIFF = 'distribution-tariff',
  CONSUMER_DOCUMENTS = 'consumer-documents',
  ORDERED_CAPACITY_FINAL_EXCESSES = 'ordered-capacity-final-excesses',
  API_KEYS = 'api-keys',
  SSO_INTEGRATIONS = 'sso-integrations',
  WORKING_PERIODS = 'working-periods',
  WORKING_PERIODS_MAIN_ORGANIZATION = 'working-periods-main-organization',
  SUBSYSTEMS = 'subsystems',

  // NOT IN THE ROUTER
  ORGANIZATIONS_PART = `organizations`,
  MAIN_ORGANIZATION_PART = `main-organization`,
  EMPLOYEES_PART = `employees`,
  SUBDIVISIONS_PART = `subdivisions`,
  GAS_DISTRIBUTION_STATIONS = 'gas-distribution-stations',
  ROLES_PART = 'roles',
  GAS_THREADS = 'gas-threads',
  METERING_POINTS = 'metering-points',
  METERING_NODES = 'metering-nodes',
  SECTORS = 'sectors',
  ALLOWED_ROUTES = 'allowed-routes',
  COUNTERPARTIES = 'counterparties',
  COMMERCIAL_METERING_POINTS_PART = 'commercial-metering-points',
  OPERATING_GAS_ROUTES_PART = 'active',
  CREATE_PART = 'create',
  REQUESTS = 'requests',
  TRUNK_ROUTE = 'trunk-route',
  MIXED_ROUTE = 'mixed-route',
  CONTRACTS = 'contracts',
  SEALS = 'seals',
  DEVICES = 'devices',
  MODEMS = 'modems',
  GAS_PIPELINES = 'gas-pipelines',
  EQUIPMENT = 'equipment',
  OWNERSHIP_HISTORY = 'ownership-history',
  AUDIT = 'audit',
  METERING_POINT_ACTS = 'metering-point-acts',
  METERING_POINT_ACTS_FORM = 'form',
  ACT_BALANCE_OWNERSHIP = 'act-balance-ownership',
  TECHNICAL_CONDITIONS_DOCUMENT = 'technical-conditions-document',
  GUARANTEE_LETTER = 'guarantee-letter',
  DOCUMENTS_AND_ACTS = 'documents',
  ACTUAL_EXPENSES = 'actual-expenses',
  ANNUAL_ORDERED_CAPACITY = 'annual-ordered-capacity',
  METERING_DEVICE_CONSUMER_INDICATORS = 'metering-device-consumer-indicators',
  DOCUMENT_PROJECT = 'project',
  VIOLATION_ACTS = 'violation-acts',
  MONITORING_DASHBOARD = 'monitoring-dashboard',
  EXPIRED_DEVICES = 'expired-devices',
  METERING_POINTS_TO_DISCONNECT = 'metering-points-to-disconnect',
  METERING_POINTS_TO_VERIFY = 'metering-points-to-verify',
  REFERENCE_BOOKS = 'reference-books',
  METERING_DEVICE_TYPES = 'metering-device-types',
}

export const getUserURL = (id: string | GridRowId) => `${Pages.USERS}/${id}`;

export const getOrganizationURL = (id: string | GridRowId) =>
  `${Pages.ORGANIZATIONS_PART}/${id}`;

export const getMainOrganizationURL = (id: string | GridRowId) =>
  `${Pages.MAIN_ORGANIZATION_PART}/${id}`;

export const getUserGroupsURL = (id: string | GridRowId) =>
  `${Pages.USER_GROUPS}/${id}`;

export const getOperatingGasRoutesURL = () =>
  `${Pages.GAS_ROUTES}/${Pages.OPERATING_GAS_ROUTES_PART}`;

export default Pages;
